import { useState } from 'react';
import { isSoundEnabled, toggleSound } from '../utils/sounds';

export default function SoundToggle() {
  const [on, setOn] = useState(isSoundEnabled);

  function handleToggle() {
    const next = toggleSound();
    setOn(next);
  }

  return (
    <button className={`sound-toggle ${on ? 'on' : ''}`} onClick={handleToggle} title="Toggle sound">
      {on ? '♪ ON' : '♪ OFF'}
    </button>
  );
}
